import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

import { Button } from "semantic-ui-react";

const SignInUp = ({ Static, signinClass, signupClass }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`header.${key}`);

  const location = useLocation();
  const navigate = useNavigate();

  const { pathname } = location;

  return (
    <section className="flex gap-[5px]">
      <button
        onClick={() => {
          if (pathname.includes("signin")) {
            return;
          }
          if (pathname.includes("signup")) {
            navigate("../signin");
            return;
          }
          navigate("signin");
        }}
        type="button"
        size="tiny"
        className={`px-[15px] py-[8px] rounded-[5px] !font-bold !text-base-dark dark:!text-base-white min-w-[55px] ${signinClass} `}
      >
        {i18n("signin")}
      </button>
      <button
        onClick={() => {
          if (pathname.includes("signup")) {
            return;
          }
          if (pathname.includes("signin")) {
            navigate("../signup");
            return;
          }
          navigate("signup");
        }}
        size="tiny"
        type="button"
        className={`px-[15px] py-[8px] rounded-[5px] dark:text-base-white text-base-dark !font-bold min-w-[55px] ${signupClass} ${
          Static && "!bg-main-color !text-white"
        }`}
      >
        {i18n("signup")}
      </button>
    </section>
  );
};

export default SignInUp;
